/* Modulo Stats with Progress Bars — counter + bar animations, lazy-initialized */
(function () {
  'use strict';

  var SELECTOR = '[data-modulo-stats-p]';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Parses a stat string like "24%", "$1,200", "4.9★" into
   *   { prefix: "", number: 24, decimals: 0, suffix: "%" }
   * Works for the common product-stat formats merchants use.
   */
  function parseValue(raw) {
    var match = String(raw).match(/^([^\d\-\.]*)([\-\d][\d,\.]*)(.*)$/);
    if (!match) return null;
    var numericStr = match[2].replace(/,/g, '');
    var n = parseFloat(numericStr);
    if (isNaN(n)) return null;
    var dec = (numericStr.split('.')[1] || '').length;
    return {
      prefix: match[1],
      number: n,
      decimals: Math.min(dec, 3),
      hasComma: match[2].indexOf(',') !== -1,
      suffix: match[3]
    };
  }

  function formatWithCommas(n) {
    var parts = n.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function animateCounter(el, target, duration) {
    var startTime = null;
    function frame(now) {
      if (startTime === null) startTime = now;
      var elapsed = now - startTime;
      var t = Math.min(elapsed / duration, 1);
      // cubic-bezier(0.22, 1, 0.36, 1) approximation
      var eased = 1 - Math.pow(1 - t, 3);
      var current = target.number * eased;
      var formatted = target.decimals > 0
        ? current.toFixed(target.decimals)
        : Math.round(current).toString();
      if (target.hasComma) formatted = formatWithCommas(formatted);
      el.textContent = target.prefix + formatted + target.suffix;
      // At t === 1, eased === 1 exactly, so current === target.number and the
      // text rendered above already matches the final state (commas included).
      // No separate "final" branch needed — it would re-format via a different
      // path and drop the comma grouping on values like "1,200".
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function init(root) {
    var duration = parseInt(root.getAttribute('data-modulo-animate-speed'), 10) || 1600;
    root.style.setProperty('--modulo-sp-anim-duration', duration + 'ms');

    // Counter elements — cache parsed targets up front so we can reset to "0" before running.
    var counters = root.querySelectorAll('[data-modulo-counter-value]');
    var targets = [];
    for (var i = 0; i < counters.length; i++) {
      var raw = counters[i].textContent.trim();
      var parsed = parseValue(raw);
      if (parsed) {
        targets.push({ el: counters[i], target: parsed });
        if (!REDUCED) {
          // Reset to 0 visually so the viewer sees the count-up, not a flash of the final value.
          var zero = parsed.decimals > 0 ? (0).toFixed(parsed.decimals) : '0';
          counters[i].textContent = parsed.prefix + zero + parsed.suffix;
        }
      }
    }

    var bars = root.querySelectorAll('[data-modulo-bar-fill]');

    if (REDUCED) {
      // Snap to final state — no animation.
      for (var b = 0; b < bars.length; b++) {
        bars[b].style.transition = 'none';
        bars[b].style.width = bars[b].getAttribute('data-modulo-bar-fill') + '%';
      }
      return;
    }

    // Kick off animations on viewport entry. `window.moduloLazyInit` already
    // guarantees we're in-view, so we can fire immediately.
    for (var j = 0; j < targets.length; j++) {
      animateCounter(targets[j].el, targets[j].target, duration);
    }
    // Bars animate via CSS transition — toggling width triggers it. Use a tiny
    // rAF delay so the browser commits the initial 0% before the target width.
    requestAnimationFrame(function () {
      for (var k = 0; k < bars.length; k++) {
        bars[k].style.width = bars[k].getAttribute('data-modulo-bar-fill') + '%';
      }
    });
  }

  if (window.moduloLazyInit) {
    window.moduloLazyInit(SELECTOR, init);
    return;
  }

  // Fallback when modulo-core.js isn't on the page.
  function boot() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
